export const getSearchParams = () => {
  return window.location.search
    .substr(1)
    .split('&')
    .reduce((qs, query) => {
      var chunks = query.split('=');
      var key = chunks[0];
      var value = decodeURIComponent(chunks[1] || '');
      var valueLower = value.trim().toLowerCase();
      if (valueLower === 'true' || value === 'false') {
        value = Boolean(value);
      } else if (!isNaN(Number(value))) {
        value = Number(value);
      }
      qs[key] = value;
      return qs;
    }, {});
};

export const updateSearchParam = (uri, key, value) => {
  // remove the hash part before operating on the uri
  var i = uri.indexOf('#');
  var hash = i === -1 ? '' : uri.substr(i);
  uri = i === -1 ? uri : uri.substr(0, i);

  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';

  if (!value) {
    // remove key-value pair if value is empty
    uri = uri.replace(new RegExp('([?&]?)' + key + '=[^&]*', 'i'), '');
    if (uri.slice(-1) === '?') {
      uri = uri.slice(0, -1);
    }
    // replace first occurrence of & by ? if no ? is present
    if (uri.indexOf('?') === -1) uri = uri.replace(/&/, '?');
  } else if (uri.match(re)) {
    uri = uri.replace(re, '$1' + key + '=' + value + '$2');
  } else {
    uri = uri + separator + key + '=' + value;
  }
  return uri + hash;
};
